module.exports = __webpack_public_path__ + "img/ic-acessibilidade-libras.d42cc62f.svg";